import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-267" data-mp="8t38tvsza2vl">
      <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/981ab013-62e7-4321-9dad-45ef6ce3a7bd/author-mark.png" alt="" aria-hidden="true" className="h-9 w-9 object-contain" width={36} height={36} decoding="async" data-id="element-268" data-mp="8ue9hmr4muih" />
      <span className="font-serif text-2xl font-semibold tracking-tight text-navy" data-id="element-269" data-mp="mtw2yffdavy6">
        Author Leverage
      </span>
    </div>;
}